import { defineSlotRecipe } from '@chakra-ui/react';
import { editableAnatomy } from '@chakra-ui/react/anatomy';

const commonStyles = {
  lineHeight: '20px',
  fontSize: '14px',
  color: 'black',
  fontWeight: 400,
};

export const editableRecipe = defineSlotRecipe({
  slots: editableAnatomy.keys(),
  className: 'ac-editable',
  base: {
    root: {
      display: 'inline-flex',
      alignItems: 'center',
      width: 'full',
      minH: '40px',
      flexGrow: 0,
      flexShrink: 0,
    },
    area: {
      width: 'full',
    },
    preview: {
      display: 'inline-flex',
      py: '1',
      px: '1',
      alignItems: 'flex-start',
      cursor: 'text',
      // width: '100%',
      height: '100%',
      // overflow: 'hidden',

      transitionProperty: 'common',
      transitionDuration: 'normal',

      wordWrap: 'normal',

      whiteSpace: 'pre-wrap',

      ...commonStyles,

      _placeholderShown: {
        color: 'grey.light.3',
      },

      _disabled: {
        userSelect: 'none',
      },

      _hidden: {
        display: 'none',
      },
    },
    input: {
      // position: 'absolute',
      resize: 'vertical',
      width: 'full',

      borderWidth: '1px',
      borderStyle: 'solid',
      rounded: 'smaller',
      borderColor: 'grey.light.3',

      backgroundColor: 'white',

      focusVisibleRing: 'none',

      ...commonStyles,
    },
  },
  variants: {
    variant: {
      heading: {
        root: {
          paddingTop: '1px',
          marginTop: '-1px',
          height: '40px',
        },
        preview: {
          color: 'black',
          fontWeight: 600,
          lineHeight: '23px',
          fontSize: '24px',
          margin: '6px -3px -2px',
        },
        input: {
          fontSize: '24px',
          fontWeight: 600,
          padding: '4px',
          margin: '-4px',
          lineHeight: '23px',
        },
      },
      'with-bg': {
        root: {
          backgroundColor: 'grey.light.0',
        },
      },
      'asset-link': {
        root: {
          maxWidth: '90%',
          minHeight: '26px',
          padding: '0px',
        },
        input: {
          borderRadius: 'small',
          fontSize: '13px',
          lineHeight: '16px',
          height: '26px',
          paddingTop: '3px',
          paddingBottom: '3px',
          marginLeft: '-10px',
          paddingLeft: '9px',
        },
        preview: {
          fontSize: '13px',
          lineHeight: '16px',
          color: 'grey.dark.2',
          padding: '0',
        },
      },
    },
    spacious: {
      true: {
        root: {
          padding: '20px',
        },
      },
    },
    withArea: {
      true: {
        preview: {
          width: '100%',
          minH: '200px',
          _placeholderShown: {
            height: '100%',
            display: 'block',
          },
        },
        input: {
          minH: '200px',
          margin: '-5px',
          padding: '8px',
        },
      },
    },
    required: {
      true: {
        preview: {
          _placeholderShown: {
            borderBottom: '2px solid {colors.halton.red}',
            paddingBottom: '10px',
            marginBottom: '-6px', // There's already a 4px margin, so just cancel 6px
            paddingTop: '2px',
          },
        },
      },
    },
  },
});
